import { render, staticRenderFns } from "./ProductTap.vue?vue&type=template&id=c1972e0c&scoped=true&"
import script from "./ProductTap.vue?vue&type=script&lang=js&"
export * from "./ProductTap.vue?vue&type=script&lang=js&"
import style0 from "./ProductTap.vue?vue&type=style&index=0&id=c1972e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1972e0c",
  null
  
)

export default component.exports